import api from './api'

const menuService = {
  // PUBLIC - cây menu active (gom theo location: { header:[...], footer:[...] })
  async getPublic() {
    const response = await api.get('/menus')
    return response.data
  },

  // ADMIN - cả mục ẩn
  async list() {
    const response = await api.get('/menus', { params: { include_inactive: 1 } })
    return response.data
  },

  async create(data) {
    const response = await api.post('/menus', data)
    return response.data
  },

  async update(id, data) {
    const response = await api.put(`/menus/${id}`, data)
    return response.data
  },

  async remove(id) {
    const response = await api.delete(`/menus/${id}`)
    return response.data
  },
}

export default menuService
